import { searchPharmacyMedicinesApi } from "../../../services/pharmacyMedicines.services";

/**
 * Medicine lookup for the ordering flows, excluding inactive medicines.
 *
 * The filter is applied twice on purpose: `is_active=true` asks the API to do
 * it, and the client-side filter covers the case where the endpoint ignores the
 * parameter. If the payload has no `is_active` field at all, neither takes
 * effect and the backend needs to expose it.
 */
export const fetchActivePharmacyMedicines = (text) =>
  searchPharmacyMedicinesApi(
    `query=${encodeURIComponent(String(text || "").toLowerCase())}&is_active=true`
  ).then((res) =>
    (res?.data || [])
      .filter((item) => item?.is_active !== false)
      .map((item) => ({
        value: item.record_id,
        label: item.name,
        // Read by AsyncSearchSelect to badge the row Available / Out of Stock.
        is_pharmacy_medicine: item.is_pharmacy_medicine,
        current_stock: item.current_stock,
      }))
  );

export default fetchActivePharmacyMedicines;
